import { usePage } from "@inertiajs/react"
import { LoginForm } from "@/components/login-form"
import { LandingPage } from "@/components/landing-page"
import type { LandingLoginProps } from "@/types/generated"

const LoginPage = () => {
  const {
    organizationName,
    openidConnectProvider,
    canSignInWithPassword,
    canSignInWithOpenidConnect,
    canSignInWithGoogle,
    canSignInWithMicrosoft
  } = usePage<{ props: LandingLoginProps }>().props as unknown as LandingLoginProps

  return (
    <LandingPage organizationName={organizationName}>
      <LoginForm
        canSignInWithPassword={canSignInWithPassword}
        canSignInWithOpenidConnect={canSignInWithOpenidConnect}
        openidConnectProvider={openidConnectProvider}
        canSignInWithGoogle={canSignInWithGoogle}
        canSignInWithMicrosoft={canSignInWithMicrosoft}
      />
    </LandingPage>
  )
}

export default LoginPage
